// angular
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { AccordionComponent } from '@app/core/components/accordion/accordion.component';
// interfaces
import { IFaq } from '@app/+products/shared/interfaces/product.interface';

@Component({
  selector: 'pwj-faq-section',
  standalone: true,
  imports: [NgClass, AccordionComponent, TranslateModule],
  templateUrl: './faq-section.component.html',
  styleUrl: './faq-section.component.scss',
})
export class FaqSectionComponent {
  // inputs
  faqData = input.required<IFaq[]>();
  verticalMargin = input<boolean>(true);
}
